import ChevronLeft from "@components/icons/ChevronLeft"
import ChevronRight from "@components/icons/ChevronRight"
import useDeviceMedia from "@hooks/useDeviceMedia"
import { addTraillingSlash, createResultsUrl } from "@lib/searchUtils"
import clsx from "clsx"
import { navigate } from "gatsby"
import React, { useMemo, useState } from "react"
import { Container } from "react-bootstrap"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import { amenitiesOptions } from "../SearchFilters/filterOptions"
import useUrlData from "../hooks/useUrlData"
import { usePropertyStore } from "../store/propertyStore"
import "./AmenitiesSelect.scss"

export const useAmenityCard = (amenity) => {
  const { removeAllAmenities, selectedAmenities, addAmenity, removeAmenity } =
    usePropertyStore((state) => ({
      removeAllAmenities: state.removeAllAmenities,
      selectedAmenities: state.selectedAmenities,
      addAmenity: state.addAmenity,
      removeAmenity: state.removeAmenity,
    }))

  // const pageUrlData = useUrlData()

  const [isPointMoved, setIsPointMoved] = useState(false)

  const isAmenitySelected =
    (amenity.value === "all" && selectedAmenities.length === 0) ||
    selectedAmenities.some(
      (selectedAmenity) => selectedAmenity.value === amenity.value
    )

    console.log(selectedAmenities)

  const onAmnityClick = () => {
    let amenitiesVal = []

    if (amenity.value === "all") {
      removeAllAmenities()
      amenitiesVal = []
    } else if (isAmenitySelected) {
      removeAmenity(amenity)
      amenitiesVal = selectedAmenities.filter(
        (selectedAmenity) => selectedAmenity.value !== amenity.value
      )
    } else {
      addAmenity(amenity)
      amenitiesVal = [...selectedAmenities, amenity]
    }

    // const url = createResultsUrl({
    //   ...pageUrlData,
    //   amenitiesVal: amenitiesVal.map((amenityItem) => amenityItem.value),
    // })

    //     // url = addTraillingSlash(url)
    //     // window.location.href = url
    // navigate(addTraillingSlash(url))
  }

  const sliderOnSwipe = {
    onPointerDown: (e) => {
      if (e.buttons === 2) return
      setIsPointMoved(false)
    },
    onPointerMove: (e) => {
      if (e.buttons === 2) return
      setIsPointMoved(true)
    },
    onPointerUp: (e) => {
      if (isPointMoved || e.buttons === 2) return

      onAmnityClick()
    },
  }

  return { isAmenitySelected, sliderOnSwipe, onAmnityClick }
}


export const useOffAmenityCard = (amenity) => {
  const { removeAllAmenities, selectedAmenities, addAmenity, removeAmenity } =
    usePropertyStore((state) => ({
      removeAllAmenities: state.removeAllAmenities,
      selectedAmenities: state.selectedAmenities,
      addAmenity: state.addAmenity,
      removeAmenity: state.removeAmenity,
    }))

  // const pageUrlData = useUrlData();
  const [isPointMoved, setIsPointMoved] = useState(false);

  // Memoize the selected status to avoid unnecessary re-renders
  // const isAmenitySelected = useMemo(() => {
  //   return (
  //     (amenity.slug === "all" && selectedAmenities.length === 0) ||
  //     selectedAmenities.some(
  //       (selectedAmenity) => selectedAmenity.slug === amenity.slug
  //     )
  //   );
  // }, [selectedAmenities]);
  const isAmenitySelected =
    (amenity.slug === "all" && selectedAmenities.length === 0) ||
    selectedAmenities.some(
      (selectedAmenity) => selectedAmenity.value === amenity.slug
    )
    console.log(isAmenitySelected)
    console.log(amenity.slug)
    console.log(selectedAmenities)

  // Use functional state updates to ensure consistency
  const onAmnityClick = () => {
    let amenitiesVal = []

    if (amenity.slug === "all") {
      removeAllAmenities()
      amenitiesVal = []
    } else if (isAmenitySelected) {
      removeAmenity(amenity)
      amenitiesVal = selectedAmenities.filter(
        (selectedAmenity) => selectedAmenity.value !== amenity.slug
      )
    } else {
      addAmenity(amenity)
      amenitiesVal = [...selectedAmenities, amenity]
    }

    // const url = createResultsUrl({
    //   ...pageUrlData,
    //   amenitiesVal: amenitiesVal.map((amenityItem) => amenityItem.value),
    // })

    //     // url = addTraillingSlash(url)
    //     // window.location.href = url
    // navigate(addTraillingSlash(url))
  }

  // Swipe handlers for the slider interaction
  const sliderOnSwipe = {
    onPointerDown: (e) => {
      if (e.buttons === 2) return;
      setIsPointMoved(false);
    },
    onPointerMove: (e) => {
      if (e.buttons === 2) return;
      setIsPointMoved(true);
    },
    onPointerUp: (e) => {
      if (isPointMoved || e.buttons === 2) return;
      onAmnityClick();
    },
  };

  return { isAmenitySelected, sliderOnSwipe, onAmnityClick };
};


const AmenityItem = ({ amenity }) => {
  const { isAmenitySelected, sliderOnSwipe } = useAmenityCard(amenity)

  return (
    <div className="amenity-item-wrap">
      <div
        className={clsx(
          "amenity-item",
          isAmenitySelected && "amenity-selected"
        )}
        {...sliderOnSwipe}
      >
        <div className="amenity-icon">
          <i className={`icon icon-${amenity.icon}`} />
        </div>
        <p className="amenity-name">{amenity.label}</p>
      </div>
    </div>
  )
}

const SlideArrow = ({ direction, onClick, currentSlide }) => {
  if (currentSlide === 0 && direction === "left") {
    return null
  }

  return (
    <div className={clsx(`slide-arrow-wrap ${direction}`)} onClick={onClick}>
      <div className="slide-arrow">
        {direction === "left" ? <ChevronLeft /> : <ChevronRight />}
      </div>
    </div>
  )
}

const AmenitiesSelect = () => {
  const { isMobile } = useDeviceMedia()

  if (isMobile) return null

  const settings = {
    className: "amenity-slider",
    dots: false,
    arrows: true,
    speed: 400,
    centerMode: false,
    swipeToSlide: true,
    variableWidth: true,
    infinite: true,
    nextArrow: <SlideArrow direction="right" />,
    prevArrow: <SlideArrow direction="left" />,
  }

  return (
    <div className="amenities-select-section">
      <Container className="amenities-slider-container">
        <Slider {...settings}>
          {/* <AmenityItem key="all" amenity={{ name: "All", slug: "all" }} /> */}
          {amenitiesOptions.map((amenity) => (
            <AmenityItem key={amenity.value} amenity={amenity} />
          ))}
        </Slider>
      </Container>
    </div>
  )
}

export default AmenitiesSelect
